import AddMandateStore from './AddMandateStore';
import BannerStore from './BannerStore';
import DebtStore from './DebtStore';
import EditMandateStore from './EditMandateStore';
import InvoiceStore from './InvoiceStore';
import MandateStore from './MandateStore';
import PersonAddressStore from './person/PersonAddressStore';
import PersonContactInfoStore from './person/PersonContactInfoStore';
import PersonDataRegistryStore from './person/PersonDataRegistryStore';
import PersonInfoStore from './person/PersonInfoStore';
import PersonPasswordStore from './person/PersonPasswordStore';
import ProductLimitsStore from './ProductLimitsStore';
import RepresentationStore from './RepresentationStore';
import SpinnerStore from './SpinnerStore';
import SsoStore from './SsoStore';
import TranslateStore from './TranslateStore';
import CookieConsentStore from './CookieConsentStore';
import { createContext } from 'react';
import PartyPrivacyProfileStore from './person/PartyPrivacyProfileStore';
export const RootStoreContext = createContext(null);
export class RootStore {
    constructor(initialState) {
        Object.defineProperty(this, "initialState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "invoiceStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "addMandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "editMandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personDataRegistryStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personContactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "debtStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productLimitsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bannerStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "personPasswordStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "representationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "partyPrivacyProfileStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "spinnerStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cookieConsentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.initialState = initialState;
        this.cookieConsentStore = new CookieConsentStore();
        this.spinnerStore = new SpinnerStore();
        this.translateStore = new TranslateStore();
        this.ssoStore = new SsoStore(this);
        this.mandateStore = new MandateStore(this);
        this.invoiceStore = new InvoiceStore(this);
        this.personInfoStore = new PersonInfoStore(this);
        this.personAddressStore = new PersonAddressStore(this);
        this.personDataRegistryStore = new PersonDataRegistryStore(this);
        this.personContactInfoStore = new PersonContactInfoStore(this);
        this.addMandateStore = new AddMandateStore(this);
        this.editMandateStore = new EditMandateStore(this);
        this.debtStore = new DebtStore(this);
        this.bannerStore = new BannerStore(this);
        this.personPasswordStore = new PersonPasswordStore(this);
        this.representationStore = new RepresentationStore(this);
        this.partyPrivacyProfileStore = new PartyPrivacyProfileStore(this);
        this.productLimitsStore = new ProductLimitsStore();
    }
}
export default RootStore;
